module.exports = __webpack_public_path__ + "img/AgentTAgent.0e47089b.png";